export const DisplayNameEnum = Object.freeze({
  FULL_NAME: 'fullName',
  LAST_INITIAL: 'lastInitial',
  ANONYMOUS: 'anonymous',
});
